import { useContext, useState } from 'react'

import Button from '@/components/view/atoms/button/Button'
import ButtonList from '@/components/view/layouts/button/ButtonList'
import Dialog from '@/components/view/molecules/dialog/Dialog'

import { ConfirmDialogContext } from './ConfirmDialogProvider'

const ConfirmDialog = () => {
  const { modal, showing, hide } = useContext(ConfirmDialogContext)
  const [loading, setLoading] = useState<boolean>(false)

  return (
    <Dialog showing={showing} text={modal.message}>
      <ButtonList>
        <Button size='large' color={'secondary'} onClick={hide} disabled={loading}>
          {modal.noText}
        </Button>
        <Button
          size='large'
          color={modal.buttonColor ?? 'critical'}
          onClick={async () => {
            setLoading(true)
            await modal.onClickYes()
            setLoading(false)
          }}
          loading={loading}
        >
          {modal.yesText}
        </Button>
      </ButtonList>
    </Dialog>
  )
}

export default ConfirmDialog
